
  <template>
    <div class="custom-control custom-checkbox custom-control-inline">
      <input  class="custom-control-input" type="checkbox" v-bind:name="name" v-bind:value="value" v-model="isChecked" v-bind:id="id"
             @input="input"
           v-on="listeners"
             />
      <label class="custom-control-label" v-bind:for="id" style="padding-top:2px">{{text}}</label>
    </div>
  </template>

<script>

  var isChecked = false;

	export default {
    name: 'input-checkbox',
		components: {
    },
    props: {
      value: {
        required: false,
        type: String,
        default: null
      },
      text: {
        required: false,
        type: String,
        default: null
      },
      name: {
        required: false,
        type: String,
        default: null
      },
      id: {
        required: true,
        type: String,
        default: null
      },
      checked: {
        required: false,
        type: Boolean,
        default: false
      },
      onclick: {
        required: false,
        type: String,
        default: ''
      }
    },
    methods: {
      input(event) {        
        this.isChecked = !this.isChecked;
        this.$emit('input', this.isChecked, this.value, this.name);
        this.$root.$emit('sentnotification', this.isChecked, this.value, event.target.name);
        if (this.onclick != null) {
          eval(this.onclick + "(this.isChecked)")
        }
      },

      setCheckBox(isChecked) {
        this.isChecked = isChecked;
      }
    },
    data() {
      return {
        isChecked: this.checked
      }
    },
    created() {
      
    },
    mounted() {
     
    },
    computed: {
      listeners() {
        const { input, ...listeners } = this.$listeners;
        return listeners;
      },
    },
    watch: {
      checked: function (newVal, oldVal) {
        this.isChecked = newVal;
        this.$forceUpdate();
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/form-components/input-checkbox.vue